import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { API, AttachmentDTO, AttachmentType, MediumDTO } from '../../../../services/api/api';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorService } from '../../../../services/error.service';
import { AttachmentService } from '../../../../services/attachment.service';
import { Mutable } from '../../../../services/global/global-interfaces';
import { OpenModalService } from '../../../../services/gui/modal/open-modal.service';
import { DateTime } from 'luxon';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-attachment-edit',
  templateUrl: './attachment-edit.component.html',
  styleUrls: ['./attachment-edit.component.scss'],
  standalone: false,
})
export class AttachmentEditComponent implements OnInit, AfterViewInit {
  @Output() fileDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  isDragOver: boolean;
  medium: Mutable<MediumDTO>;
  @Input() selectedMode: string | undefined;
  url: string;
  @ViewChild('uploadTmp') private uploadTmp: TemplateRef<object>;
  @ViewChild('linkTmp') private linkTmp: TemplateRef<object>;
  @ViewChild('optionsTmp') private optionsTmp: TemplateRef<object>;

  constructor(
    public openModal: OpenModalService,
    private cdRef: ChangeDetectorRef,
    private errorHandler: ErrorService,
    private api: API,
    private modal: ModalService,
    private translate: TranslateService,
    public attachmentService: AttachmentService,
    private destroyRef: DestroyRef
  ) {}

  _selectedAttachment: AttachmentDTO;

  get selectedAttachment(): AttachmentDTO {
    return this._selectedAttachment;
  }

  @Input() set selectedAttachment(val: AttachmentDTO) {
    this._selectedAttachment = val;
  }

  ngOnInit(): void {
    if (this.selectedAttachment && !this.selectedMode) {
      this.selectedMode = this._selectedAttachment.attachmentType;
    }
  }

  selectTemplate(): TemplateRef<object> {
    switch (this.selectedMode) {
      case AttachmentType.UPLOAD: {
        this.createSafeUrl();
        this.setPreview();
        return this.uploadTmp;
      }
      case AttachmentType.LINK: {
        this.createSafeUrl();
        return this.linkTmp;
      }
      default: {
        return this.optionsTmp;
      }
    }
  }

  setPreview() {
    // TODO Waiting for thumbnails
    this.medium = new MediumDTO();
    this.medium.contentType = this._selectedAttachment.fileType;
    this.medium.stillImage = this._selectedAttachment.fileLink;
    this.medium.url = this._selectedAttachment.fileLink;
    this.medium.name = this._selectedAttachment.fileName;
    this.medium.id = DateTime.local().toMillis();
  }

  createSafeUrl() {
    if (this.selectedAttachment) {
      this.url = this.attachmentService.updateIframeUrl(this.selectedAttachment);
    }
  }

  deleteAttachment(): boolean {
    if (this.selectedAttachment) {
      this.modal
        .confirm({
          title: this.translate.instant('lang.globals.deleteElementValue', { value: this.selectedAttachment.name }),
          message: this.translate.instant('lang.globals.deleteElementValueQuestion', { value: this.selectedAttachment.name }),
          yes: this.translate.instant('lang.globals.yes'),
          no: this.translate.instant('lang.globals.no'),
        })
        .then((result: boolean) => {
          if (result) {
            this.api
              .shared_Attachment_deleteAttachment(this.selectedAttachment.id)
              .pipe(takeUntilDestroyed(this.destroyRef), take(1))
              .subscribe({
                next: () => {
                  this.fileDeleted.emit(true);
                },
                error: error => {
                  this.errorHandler.errorHandler(error);
                },
              });
          }
        })
        .catch(() => {});
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }
}
